export default __webpack_public_path__ + "images/af817c7ae590e5a5d40da5466ed9a083-stomach.png";